function initMap() {
  const usa = {
    lat: 37.0902,
    lng: -95.7129,
  };
  const map = new google.maps.Map(document.getElementById("map"), {
    center: usa,
    zoom: 4,
    styles: [
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#e9e9e9",
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
          {
            color: "#f5f5f5",
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#ffffff",
          },
          {
            lightness: 29,
          },
          {
            weight: 0.2,
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
          {
            color: "#ffffff",
          },
          {
            lightness: 18,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
          {
            color: "#ffffff",
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
          {
            color: "#f5f5f5",
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            color: "#dedede",
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ffffff",
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        elementType: "labels.text.fill",
        stylers: [
          {
            saturation: 36,
          },
          {
            color: "#333333",
          },
          {
            lightness: 40,
          },
        ],
      },
      {
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [
          {
            color: "#f2f2f2",
          },
          {
            lightness: 19,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#fefefe",
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#fefefe",
          },
          {
            lightness: 17,
          },
          {
            weight: 1.2,
          },
        ],
      },
    ],
  });
  const infoWindow = new google.maps.InfoWindow({
    minWidth: 200,
  });
  const bounds = new google.maps.LatLngBounds();

  const fehMarker =
    "https://cdn.shopify.com/s/files/1/0710/2948/9884/files/fox-home.webp?v=1724253841";

  for (let i = 0; i < markers.length; i++) {
    const marker = new google.maps.Marker({
      position: { lat: markers[i]["lat"], lng: markers[i]["lng"] },
      map: map,
      icon: fehMarker,
    });
    function createInfoWindow() {
      const infoWindowContent = `
            <div class="feh-content">
            <a href="${markers[i]["website"]}">
                <h3>${markers[i]["locationName"]}</h3>
            </a>
            <address>
                <p>${markers[i]["address"]}</p>
            </address>
            <p>Tel: ${markers[i]["tel"]}</p>
            <p>Email: ${markers[i]["email"]}</p>
            <p>Website: ${markers[i]["website"]}</p>
            <div class= "feh-content__buttons">
            <a href="http://maps.google.com/maps?saddr=${markers[i]["lat"]},${markers[i]["lng"]}&daddr=${markers[i]["lat"]},${markers[i]["lng"]}">
                <button class="button button--primary">
                GET DIRECTIONS
                </button>
            </a>
            <a href="tel:${markers[i]["tel"]}">
                <button class="button button--primary">
                CALL NOW
                </button>
            </a>
            </div>
            </div>
        `;

      google.maps.event.addListener(marker, "click", function () {
        infoWindow.setContent(infoWindowContent);
        infoWindow.open(map, marker);
      });
    }
    createInfoWindow();
    infoWindow.addListener("closeclick", function () {
      map.fitBounds(bounds);
    });
    bounds.extend(new google.maps.LatLng(markers[i]["lat"], markers[i]["lng"]));
    map.fitBounds(bounds);
  }

  autoComplete = new google.maps.places.Autocomplete(
    document.getElementById("store_locator_address_field"),
    {
      types: ["geocode"],
      componentRestrictions: {
        country: [
          "AU",
          "FR",
          "US",
          "SG",
          "GB",
          "DE",
          "VN",
          "DK",
          "BE",
          "CH",
          "KR",
          "PH",
          "NO",
          "CA",
          "NZ",
          "NL",
          "JP",
          "AF",
        ],
      },
      fields: ["geometry"],
    }
  );
  autoComplete.addListener("place_changed", onPlaceChange);

  // Search button event listener
  document
    .querySelector(".dealer__locator__container .button--primary")
    .addEventListener("click", onPlaceChange);

  function onPlaceChange() {
    let place = autoComplete.getPlace();

    if (!place.geometry) {
      document.getElementById("store_locator_address_field").placeholder =
        "Enter a valid location";
      return;
    }

    const location = place.geometry.location;
    map.setCenter(location);
    map.setZoom(9);

    const nearbyLocations = markers.filter((marker) => {
      const distance = getDistanceFromLatLonInKm(
        location.lat(),
        location.lng(),
        marker.lat,
        marker.lng
      );
      return distance <= 100; // Filter within 100 km radius
    });

    updateLocationDetails(nearbyLocations);
  }

  // Haversine formula to calculate the distance between two points on the Earth
  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  }

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  function updateLocationDetails(nearbyLocations) {
    const locationDetailsDiv = document.querySelector(".location__details");
    locationDetailsDiv.innerHTML = ""; // Clear existing content

    if (nearbyLocations.length === 0) {
      locationDetailsDiv.innerHTML = "<p>No locations found nearby.</p>";
      return;
    }

    nearbyLocations.forEach((location) => {
      const content = `
            <div class="feh-content">
                <a href="${location.website}">
                    <h3>${location.locationName}</h3>
                </a>
                <address>
                    <p>${location.address}</p>
                </address>
                <p>Tel: ${location.tel}</p>
                <p>Email: ${location.email}</p>
                <p>Website: ${location.website}</p>
                <div class="feh-content__buttons">
                    <a href="http://maps.google.com/maps?saddr=${location.lat},${location.lng}&daddr=${location.lat},${location.lng}">
                        <button class="button button--primary">GET DIRECTIONS</button>
                    </a>
                    <a href="tel:${location.tel}">
                        <button class="button button--primary">CALL NOW</button>
                    </a>
                </div>
            </div>
        `;
      locationDetailsDiv.innerHTML += content;
    });
  }
}
